import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container , Grid } from 'semantic-ui-react';
import TopBar from '../components/topBar';
import Footer from '../components/footer';

class FQandAPage extends Component {
  componentDidMount() {
    window.scrollTo(0,0);
  }
  render() {
    return (
      <div>
        <TopBar/>
        <Grid stackable style={{ backgroundColor : 'white' , minHeight : '100vh' }}>
          <Grid.Row>
            <Grid.Column><p>Comming Soon...</p></Grid.Column>
          </Grid.Row>
        </Grid>
        <Footer/>
      </div>
    );
  }
}

export default connect(null,null)(FQandAPage)



/** WEBPACK FOOTER **
 ** ./src/containers/fqandaPage.js
 **/